export enum SignUpErrors {
  UserAlreadyExist = 'User already exists',
  EmailFormattingError = 'Invalid email address format',
}

export enum ConfirmationErrors {
  UserAlreadyConfirmed = 'User is already confirmed.',
}
